/** Reserved instance synchronized by the legacy Authorize.Net configuration endpoints. */
export const LEGACY_AUTHORIZE_NET_INSTANCE_ID = 'legacy_authorize_net_default';
